import type { HTMLAttributes } from 'react'
import { clsx } from 'clsx'

export function Badge({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={clsx('ml-1.5 rounded-full bg-panel-2 px-2 py-1 text-[11px] font-semibold text-accent', className)}
      {...props}
    />
  )
}
